import React, { useEffect, useState } from 'react'
import './collaborators-landing.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import CollaboratorsOrg from './collaborators-org.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const CollaboratorsLanding = ({
  gameData,
  orgs,
  formData,
  saveData
}) => {

  const [ collabSystem, setCollabSystem ] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!gameData) return;
    if (gameData.orgId) {
      setCollabSystem('org');
    }
  }, [gameData])

  function changeCollabSystem(system) {
    setCollabSystem(system);
  }

  return (
    <div className='collaborators-landing'>
      <div className='g-card collab-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        <div className='card-title'>
          Settings: Collaborators
        </div>
        <div className="g-space-1"></div>
        <div className='card-subtitle'>
          Manage who has access to this game and what they can do.
        </div>
        <div className="g-space-2"></div>
        <div className='collab-content'>
          {
            (gameData && !gameData.orgId && !collabSystem) 
            ?
            <div className='button-group'>
              <button 
                className='g-button' 
                onClick={() => setCollabSystem('premium')}>
                <ImageContainer src="/images/icons/premium.png" className='icon' />
                Invite a Premium Member
              </button>
              <button className='g-button' onClick={() => setCollabSystem('org')}>
                <ImageContainer src="/images/icons/enterprise.png" className='icon' />
                Invite a Member of Your Organization
              </button>
            </div>
            :
            (gameData && collabSystem === 'org')
            ?
            <CollaboratorsOrg
              gameData={gameData}
              orgs={orgs}
              formData={formData}
              saveData={saveData}
              changeCollabSystem={changeCollabSystem} />  
            :
            (gameData && collabSystem === 'premium')
            ?
            <div className='center-col'>
              <h3>Coming Soon!</h3>
              <button className='g-button small-btn' onClick={() => changeCollabSystem('org')}>
                Back to Org Invites
              </button>
            </div>
            : null
          }
        </div>
      </div>
    </div>
  )
}

export default CollaboratorsLanding